import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private isFullscreenMode = false;

  constructor() {
    if (localStorage.getItem('engagementPopUpMode')) {
      const mode = localStorage.getItem('engagementPopUpMode') || 'false';
      this.isFullscreenMode = JSON.parse(mode);
    }
  }

  getFullscreenMode() {
    return this.isFullscreenMode;
  }

  setFullscreenMode(screenMode) {
    this.isFullscreenMode = screenMode;
    localStorage.setItem(
      'engagementPopUpMode',
      this.isFullscreenMode.toString()
    );
  }
}
